import SolarCalculator from "@/components/SolarCalculator";

function App() {
  return <SolarCalculator />;
}

export default App;
